define('MultipleAddToCartPLP.View', [
    'GlobalViews.Confirmation.View',
    'multipleaddtocartplp.tpl',
    'Product.Model',
    'SC.Configuration',
    'Backbone',
    'jQuery',
    'Url',
    'underscore',
    'Utils',
    'MultipleAddToCartPLP.Cart.Confirmation.View'
], function ProductBadgesView(
    GlobalViewsConfirmationView,
    multipleAddToCartPLPTpl,
    ProductModel,
    Configuration,
    Backbone,
    jQuery,
    Url,
    _,
    Utils,
    MultipleAddToCartPLPCartConfirmationView
) {
    'use strict';

    return Backbone.View.extend({
        template: multipleAddToCartPLPTpl,
        events: {
            'click [data-type="multi-add"]': 'multiAdd'
        },
        itemsQuantities: {},
        initialize: function initialize(options) {
            _.extend(this, options);
            this.on('afterViewRender', function setEmptyItemsQuantities() {
                this.itemsQuantities = {};
            });
        },
        isMultiCartEmpty: function isMultiCartEmpty() {
            var keys = Object.keys(this.itemsQuantities);
            var self = this;

            if (keys.length === 0) return true;

            return _.every(keys, function checkIfEveryItemEmpty(key) {
                return self.itemsQuantities[key] === '0';
            });
        },
        updateItemsQuantities: function updateItemQuantity(itemId, quantity) {
            this.itemsQuantities[itemId] = quantity;
            this.updateTotals();
        },
        getItemById: function getItemById(itemId) {
            var plp = this.application.getComponent('PLP');
            return _.find(plp.getItemsInfo(), function findItem(itemInfo) {
                return parseInt(itemInfo.internalid, 10) === parseInt(itemId, 10);
            });
        },
        getTotals: function getTotals() {
            var totalPrice = 0;
            var totalQuantity = 0;
            var self = this;
            _.each(this.itemsQuantities, function eachCollection(quantity, itemId) {
                var item = self.getItemById(itemId);
                totalPrice += item.keyMapping_price * parseInt(quantity, 10);
                totalQuantity += parseInt(quantity, 10);
            });

            return {
                totalPrice: totalPrice,
                totalQuantity: totalQuantity
            };
        },
        updateTotals: function updateTotals() {
            var totals = this.getTotals();

            if (totals.totalQuantity) {
                this.$('.multiple-add-to-cart-plp-actions-wrapper').show();
            } else {
                this.$('.multiple-add-to-cart-plp-actions-wrapper').hide();
            }

            this.$('.multiple-add-to-cart-plp-table-total-quantity').text(totals.totalQuantity);
            this.$('.multiple-add-to-cart-plp-table-total-price').text(_.formatCurrency(totals.totalPrice));
            this.$('.multiple-add-to-cart-plp-button').prop('disabled', !totals.totalQuantity);

            window.isNavigationBlocked = totals.totalQuantity > 0;
        },
        multiAdd: function multiAdd(e) {
            var products = [];
            var self = this;
            var confirmationView;
            e.preventDefault();
            this.$('[data-overlay]').addClass('active');
            this.$('[data-type="multi-add"]').addClass('loading');

            _.each(this.itemsQuantities, function eachModels(quantity, itemid) {
                if (parseInt(quantity, 10) > 0) {
                    products.push({
                        item: {
                            internalid: self.getItemById(itemid).internalid
                        },
                        quantity: parseInt(quantity, 10)
                    });
                }
            });

            this.$('[data-type="multi-add"]').addClass('loading');
            this.$('.multiple-add-to-cart-plp-button').prop('disabled', true);
            this.$('.multiple-add-to-cart-plp-button-text').text('Adding to cart..');
            this.options.application.getComponent('Cart').addLines({ lines: products })
                .done(function addProducts() {
                    Backbone.Events.trigger('MultipleAddToCart:ClearQuantities');
                    confirmationView = new MultipleAddToCartPLPCartConfirmationView({});
                    self.options.application.getComponent('Layout').showContent(confirmationView, { showInModal: true });
                    self.clearQuantities();
                    self.updateTotals();
                })
                .fail(function failAddProducts() {
                    self.$('.multiple-add-to-cart-plp-error-message').show().html(Utils.translate('There was an error while adding to cart'));
                    _.delay(function removeMessage() {
                        self.$('.multiple-add-to-cart-plp-error-message').fadeOut();
                    }, 4000);
                })
                .always(function alwaysAddProducts() {
                    self.$('.multiple-add-to-cart-plp-button-text').text('Add to cart');
                    self.$('[data-overlay]').removeClass('active');
                    self.$('[data-type="multi-add"]').removeClass('loading');
                });
        },
        clearQuantities: function clearQuantities() {
            this.itemsQuantities = {};
            this.render();
        },
        destroy: function destroy(softDestroy) {
            this.itemsQuantities = {};
            this.backboneHistoryStopped = true;
            this._destroy(softDestroy);
        },
        getContext: function getContext() {
            return {
                showAddToCartButton: Configuration.get('siteSettings.requireloginforpricing', 'F') === 'F'
            };
        }
    });
});
